/* eslint-disable require-jsdoc */
import React, { useEffect } from 'react';
import MainRoutes from './main-routes';
import CreateGlobalStyle from './global-style';
import { ParallaxProvider } from 'react-scroll-parallax';
import lozad from 'lozad';
import 'react-phone-input-2/lib/style.css';
import useAutoClickChatButton from 'hooks/useAutoClickChatButton';

function App() {
    useEffect(() => {
        const el = document.querySelectorAll(['img', 'video']);
        const observer = lozad(el);
        observer.observe();
    });

    useAutoClickChatButton();

    return (
        <>
            <CreateGlobalStyle />
            <ParallaxProvider>
                <MainRoutes />
            </ParallaxProvider>
        </>
    );
}

export default App;
